export default "__VITE_ASSET__C0UA3tbF__"